<template>
  <div class="modal show fade modal-primary text-left" style="display: block;" v-if="show">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content" style="max-height: 90vh;">
        <div class="modal-header">
          <h5 class="modal-title">Assign Stores</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="max-height: calc(90vh - 120px); overflow-y: auto;">
          <div class="row">
            <!-- Main Content Column -->
            <div class="col-md-9 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">All Stores <span class="badge badge-pill ml-1 badge-light-primary">
                      Selected {{ Object.keys(allSelectedStores).length }}
                    </span></h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal" @submit.prevent>
<!--                    <div class="row">-->
<!--                      <div class="col-md-12 user_status mb-2">-->
<!--                        <div class="input-group">-->
<!--                          <input class="form-control" type="text" v-model="search" placeholder="Search here..."/>-->
<!--                          <div class="input-group-append">-->
<!--                            <button type="button" class="btn btn-primary" @click="handleSearch" :disabled="loadingSearch">-->
<!--                              <span v-if="!loadingSearch">Search</span>-->
<!--                              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>-->
<!--                            </button>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="row">
                      <h6 class="section-label mx-1 mb-2">Stores</h6>
                      <div class="col-12 mb-2">
                        <div v-if="loading && paginationData.currentPage === 1" class="text-center py-4">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                        <div v-else-if="storeList.length === 0" class="text-center text-muted py-4">
                          No stores available
                        </div>
                        <div v-else>
                          <div class="custom-control custom-switch mb-1" v-for="(store, index) in storeList" :key="store.id">
                            <input :id="'store_' + index" type="checkbox" v-if="typeof(store.checked) != 'undefined'" class="custom-control-input" v-model="store.checked" @change="updateSelection(store.id, store.checked)"/>
                            <label :class="typeof(store.checked) != 'undefined' ? 'custom-control-label':''" :for="'store_' + index">
                              {{ store.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 text-center" v-if="hasMoreItems && !loadingMore">
                        <button class="btn btn-primary btn-sm" @click="loadMore">
                          Load More
                        </button>
                      </div>
                      <div class="col-12 text-center" v-if="loadingMore">
                        <div class="spinner-border text-primary" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                      <div class="col-12 text-muted text-center" v-if="!hasMoreItems && storeList.length > 0">
                        No more items to load
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Selected Stores Panel -->
            <div class="col-md-3 col-12">
              <div class="card">
<!--                <div class="card-header">-->
<!--                  <h4 class="card-title d-flex justify-content-between align-items-center">-->
<!--                    Selected Stores-->
<!--                    <span class="badge badge-pill ml-1 badge-light-primary">-->
<!--                      {{ Object.keys(allSelectedStores).length }}-->
<!--                    </span>-->
<!--                  </h4>-->
<!--                </div>-->
<!--                <div class="card-body p-0">-->
<!--                  <div class="table-responsive">-->
<!--                    <table class="table table-hover">-->
<!--                      <tbody>-->
<!--                      <tr v-for="(selected, id) in allSelectedStores" :key="id">-->
<!--                        <td class="py-1">-->
<!--                          {{ getStoreName(id) }}-->
<!--                        </td>-->
<!--                        <td class="text-right py-1">-->
<!--                          <button-->
<!--                              type="button"-->
<!--                              class="btn btn-sm btn-icon rounded-circle"-->
<!--                              @click="removeSelection(id)"-->
<!--                          >-->
<!--                            <i class="fas fa-times text-danger"></i>-->
<!--                          </button>-->
<!--                        </td>-->
<!--                      </tr>-->
<!--                      <tr v-if="Object.keys(allSelectedStores).length === 0">-->
<!--                        <td colspan="2" class="text-center text-muted py-2">-->
<!--                          No stores selected-->
<!--                        </td>-->
<!--                      </tr>-->
<!--                      </tbody>-->
<!--                    </table>-->
<!--                  </div>-->
<!--                </div>-->
                <div class="card-footer d-flex justify-content-between align-items-center">
                  <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      @click="clearAllSelections"
                      v-if="Object.keys(allSelectedStores).length > 0"
                  >
                    Clear All
                  </button>
                  <button type="button" class="btn btn-primary" @click="assignStores" :disabled="loading">
                    <span v-if="!loading">Assign</span>
                    <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  props: ['show', 'preSelectedStoreIds'],
  data() {
    return {
      loading: false,
      storeList: [],
      intactStoreList: [],
      selectedStores: {},
      allSelectedStores: {},
      selectedStoreNames: {},
      explicitlyUnselectedStores: {},
      search: '',
      paginationData: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      loadingMore: false,
      loadingSearch: false,
      currentSearchQuery: '',
      hasLoadedInitialSelections: false,
    }
  },
  computed: {
    hasMoreItems() {
      return this.storeList.length < this.paginationData.total;
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.getStores();
      }
    },
    preSelectedStoreIds(newVal) {
      this.initializeSelectedStores();
    }
  },
  mounted() {
    this.initializeSelectedStores();
  },
  methods: {
    initializeSelectedStores() {
      this.selectedStores = {};
      this.allSelectedStores = {};
      this.selectedStoreNames = {};
      if (this.preSelectedStoreIds && Array.isArray(this.preSelectedStoreIds)) {
        this.preSelectedStoreIds.forEach(storeId => {
          this.selectedStores[storeId] = true;
          this.allSelectedStores[storeId] = true;
        });
      }
    },
    updateSelection(id, isChecked) {
      if (isChecked) {
        this.allSelectedStores[id] = true;
        delete this.explicitlyUnselectedStores[id];
        const item = this.storeList.find(f => f.id == id) ||
            this.intactStoreList.find(f => f.id == id);
        if (item) {
          this.selectedStoreNames[id] = item.name;
        }
      } else {
        delete this.allSelectedStores[id];
      }
    },
    removeSelection(id) {
      delete this.allSelectedStores[id];
      this.explicitlyUnselectedStores[id] = true;
      const item = this.storeList.find(f => f.id == id);
      if (item) {
        item.checked = false;
      }
    },
    clearAllSelections() {
      this.storeList.forEach(item => {
        item.checked = false;
      });
      this.allSelectedStores = {};
      this.explicitlyUnselectedStores = {};
    },
    getStoreName(id) {
      return this.storeList.find(f => f.id == id)?.name ||
          this.intactStoreList.find(f => f.id == id)?.name ||
          this.selectedStoreNames[id] ||
          `Store ${id}`;
    },
    handleSearch() {
      if (this.loadingSearch) return;

      this.loadingSearch = true;
      this.currentSearchQuery = this.search;
      this.paginationData.currentPage = 1;
      this.storeList = [];

      this.getStores(true).finally(() => {
        this.loadingSearch = false;
      });
    },
    loadMore() {
      if (this.hasMoreItems && !this.loadingMore) {
        this.paginationData.currentPage++;
        this.getStores(!!this.currentSearchQuery);
      }
    },
    getStores(forSearch = false) {
      this.loadingMore = true;

      let requestData = {
        paginate: true,
        page: this.paginationData.currentPage,
        perPage: this.paginationData.perPage
      };

      if (this.currentSearchQuery) {
        requestData.search = this.currentSearchQuery;
      }

      return this.makeRequest('post', 'v1/get-stores', requestData, {}, false)
          .then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                const newItems = callResponse.response.data.data.stores.data || [];

                const processedItems = newItems.map(item => ({
                  ...item,
                  checked: !!this.allSelectedStores[item.id] &&
                      !this.explicitlyUnselectedStores[item.id]
                }));

                if (callResponse.response.data.data.stores.paginationData) {
                  this.paginationData = {
                    ...this.paginationData,
                    ...callResponse.response.data.data.stores.paginationData
                  };
                }

                if (this.paginationData.currentPage === 1) {
                  this.storeList = processedItems;
                } else {
                  this.storeList = [...this.storeList, ...processedItems];
                }

                // Initialize selected stores from processed items
                processedItems.forEach(item => {
                  if (item.checked) {
                    this.selectedStores[item.id] = true;
                    this.allSelectedStores[item.id] = true;
                    this.selectedStoreNames[item.id] = item.name;
                  }
                });

                if(this.intactStoreList.length == 0) {
                  this.intactStoreList = [...this.storeList];
                }
              }
            }
          })
          .finally(() => {
            this.loadingMore = false;
          });
    },
    assignStores() {
      const selectedStoreIds = Object.keys(this.allSelectedStores);
      this.$emit('assign', selectedStoreIds);
    }
  }
}
</script>

<style scoped>
.table td {
  vertical-align: middle;
}
.btn-icon {
  width: 24px;
  height: 24px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.card-footer {
  background-color: #f8f9fa;
}
</style>
